export enum ProcessEngineApiActionType {
    CONFIRM_BUSINESS_RELATIONSHIP = 'process-engine.confirm-business-relationship',
    CONFIRM_BUSINESS_RELATIONSHIP_FAILURE = 'process-engine.confirm-business-relationship.failure',
    CONFIRM_BUSINESS_RELATIONSHIP_SUCCESS = 'process-engine.confirm-business-relationship.success',
    CREATE_EBANKING_CONTRACT = 'process-engine.create-e-banking-contract',
    CREATE_EBANKING_CONTRACT_FAILURE = 'process-engine.create-e-banking-contract.failure',
    CREATE_EBANKING_CONTRACT_SUCCESS = 'process-engine.create-e-banking-contract.success',
    CREATE_NO_INTEREST = 'process-engine.create-no-interest',
    CREATE_NO_INTEREST_FAILURE = 'process-engine.create-no-interest.failure',
    CREATE_NO_INTEREST_SUCCESS = 'process-engine.create-no-interest.success',
    CREATE_POPUP_RESPONSE = 'process-engine.create-popup-response',
    CREATE_POPUP_RESPONSE_FAILURE = 'process-engine.create-popup-response.failure',
    CREATE_POPUP_RESPONSE_SUCCESS = 'process-engine.create-popup-response.success',
    CREATE_POWER_OF_ATTORNEY = 'process-engine.create-power-of-attorney',
    CREATE_POWER_OF_ATTORNEY_FAILURE = 'process-engine.create-power-of-attorney.failure',
    CREATE_POWER_OF_ATTORNEY_SUCCESS = 'process-engine.create-power-of-attorney.success',
    DELETE_ACCOUNT = 'process-engine.delete-account',
    DELETE_ACCOUNT_FAILURE = 'process-engine.delete-account.failure',
    DELETE_ACCOUNT_SUCCESS = 'process-engine.delete-account.success',
    DELETE_CARD = 'process-engine.delete-card',
    DELETE_CARD_FAILURE = 'process-engine.delete-card.failure',
    DELETE_CARD_SUCCESS = 'process-engine.delete-card.success',
    DELETE_EBANKING_CONTRACT = 'process-engine.delete-e-banking-contract',
    DELETE_EBANKING_CONTRACT_FAILURE = 'process-engine.delete-e-banking-contract.failure',
    DELETE_EBANKING_CONTRACT_SUCCESS = 'process-engine.delete-e-banking-contract.success',
    DELETE_POWER_OF_ATTORNEY = 'process-engine.delete-power-of-attorney',
    DELETE_POWER_OF_ATTORNEY_FAILURE = 'process-engine.delete-power-of-attorney.failure',
    DELETE_POWER_OF_ATTORNEY_SUCCESS = 'process-engine.delete-power-of-attorney.success',
    FETCH_ALL_INSTANCES = 'process-engine.fetch-all-instances',
    FETCH_ALL_INSTANCES_FAILURE = 'process-engine.fetch-all-instances.failure',
    FETCH_ALL_INSTANCES_SUCCESS = 'process-engine.fetch-all-instances.success',
    FETCH_ALL_POPUP_RESPONSES = 'process-engine.fetch-all-popup-responses',
    FETCH_BSI_CASES = 'process-engine.fetch-bsi-cases',
    FETCH_BSI_CASES_FAILURE = 'process-engine.fetch-bsi-cases.failure',
    FETCH_BSI_CASES_SUCCESS = 'process-engine.fetch-bsi-cases.success',
    FETCH_INSTANCE = 'process-engine.fetch-instance',
    FETCH_INSTANCE_FAILURE = 'process-engine.fetch-instance.failure',
    FETCH_INSTANCE_SUCCESS = 'process-engine.fetch-instance.success',
    FETCH_POPUP_RESPONSES = 'process-engine.fetch-popup-responses',
    FETCH_POPUP_RESPONSES_SUCCESS = 'process-engine.fetch-popup-responses.success',
    FETCH_POPUP_RESPONSES_FAILURE = 'process-engine.fetch-popup-responses.failure',
    MARK_POPUP_NOTIFICATION_FOR_DELETION = 'process-engine.mark-popup-notification-for-deletion',
    MODIFY_ACCOUNT_CATEGORY = 'process-engine.modify-account-category',
    MODIFY_ACCOUNT_CATEGORY_FAILURE = 'process-engine.modify-account-category.failure',
    MODIFY_ACCOUNT_CATEGORY_SUCCESS = 'process-engine.modify-account-category.success',
    MODIFY_ADDRESS = 'process-engine.modify-address',
    MODIFY_ADDRESS_FAILURE = 'process-engine.modify-address.failure',
    MODIFY_ADDRESS_SUCCESS = 'process-engine.modify-address.success',
    MODIFY_CARD_LIMITS = 'process-engine.modify-card-limits',
    MODIFY_CARD_LIMITS_FAILURE = 'process-engine.modify-card-limits.failure',
    MODIFY_CARD_LIMITS_SUCCESS = 'process-engine.modify-card-limits.success',
    MODIFY_CIVIL_STATUS = 'process-engine.modify-civil-status',
    MODIFY_CIVIL_STATUS_FAILURE = 'process-engine.modify-civil-status.failure',
    MODIFY_CIVIL_STATUS_SUCCESS = 'process-engine.modify-civil-status.success',
    MODIFY_EMAIL = 'process-engine.modify-email',
    MODIFY_EMAIL_FAILURE = 'process-engine.modify-email.failure',
    MODIFY_EMAIL_SUCCESS = 'process-engine.modify-email.success',
    MODIFY_NAME = 'process-engine.modify-name',
    MODIFY_NAME_FAILURE = 'process-engine.modify-name.failure',
    MODIFY_NAME_SUCCESS = 'process-engine.modify-name.success',
    MODIFY_PHONE = 'process-engine.modify-phone',
    MODIFY_PHONE_FAILURE = 'process-engine.modify-phone.failure',
    MODIFY_PHONE_SUCCESS = 'process-engine.modify-phone.success',
    ORDER_CARD = 'process-engine.order-card',
    ORDER_CARD_FAILURE = 'process-engine.order-card.failure',
    ORDER_CARD_SUCCESS = 'process-engine.order-card.success',
    POST_BSI_CASE = 'process-engine.post-bsi-case',
    POST_BSI_CASE_FAILURE = 'process-engine.post-bsi-case.failure',
    POST_BSI_CASE_SUCCESS = 'process-engine.post-bsi-case.success',
    PROCESS_TASK = 'process-engine.process-task',
    PROCESS_TASK_FAILURE = 'process-engine.process-task.failure',
    PROCESS_TASK_SUCCESS = 'process-engine.process-task.success',
    REMOVE_POPUP_NOTIFICATIONS = 'process-engine.remove-popup-notifications',
    SELECT_POPUP_NOTIFICATION = 'process-engine.select-popup-notification',
    START_BSI_PROCESS = 'process-engine.start-bsi-process',
    START_BSI_PROCESS_FAILURE = 'process-engine.start-bsi-process.failure',
    START_BSI_PROCESS_SUCCESS = 'process-engine.start-bsi-process.success',
    SUBMIT_PRODUCT_ORDER = 'process-engine.submit-product-order',
    SUBMIT_PRODUCT_ORDER_FAILURE = 'process-engine.submit-product-order.failure',
    SUBMIT_PRODUCT_ORDER_SUCCESS = 'process-engine.submit-product-order.success',
}
